import { FETCH_FACILITATOR, FETCH_FACILITATOR_SUCCESS, FETCH_FACILITATOR_FAILURE, CLEAR_FACILITATOR } from '../actions';

const initialState = {
  facilitator: {},
  loading: true,
  err: null,
  haveData: false
};

export const reducer = (state = initialState, action) => {
  switch(action.type) {
    case FETCH_FACILITATOR:
      return {
        ...state,
        loading: true,
        err: null,
        haveData: false
      };
    case FETCH_FACILITATOR_SUCCESS:
      return {
        ...state,
        loading: false,   
        haveData: true,     
        facilitator: action.data
      };
    case FETCH_FACILITATOR_FAILURE:
      return {
        ...state,
        loading: false,
        haveData: false,
        err: action.error,
        facilitator: {}
      };
    case CLEAR_FACILITATOR:
      return initialState;
    default:
      return state;
  }
}